import React, { useEffect, useRef, useState } from "react";
import "./../login/Login.scss";
import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import Label from "../../components/ui/label/Label";
import Input from "../../components/ui/inputs/input/Input";
import Iconify from "../../components/ui/iconify/Iconify";
import Buttons from "../../components/ui/button/Buttons";
import { useNavigate } from "react-router-dom";
import { useResetPasswordMutation } from "../../app/services/authAPI";
import { getAuthProps } from "../../lib/authenticationLibrary";
import ToastService from "../../services/toastService/ToastService";
import FormCreator from "../../components/forms/FormCreator";
import ResetPasswordData from "./ResetPassword.data";

const ResetPassword = () => {
  const resetPasswordRef = useRef();
  const authData = getAuthProps();
  const [resetForm, setResetForm] = useState(ResetPasswordData);

  const navigate = useNavigate();

  const [resetPassword, {
    isLoading: isResetting,
    isSuccess: isReset,
    data: resetPasswordData
  },] = useResetPasswordMutation();

  const handleClick = () => {
    let resetPasswordData = resetPasswordRef.current.getFormData();
    if (resetPasswordData) {
      const req = {
        userID: authData.user.userID,
        Password: resetPasswordData.psConfirmPassword360,
        newPassword: resetPasswordData.psPassword360,
        EmailAddress: resetPasswordData.email,
        passwordResetRequired: true
      }
      resetPassword(req);
    }
  };

  useEffect(() => {
    if (authData) {
      const email =
        authData.user?.emailAddress || authData.user?.EmailAddress || "";

      if (resetForm.initialState.email !== email) {
        const newForm = { ...resetForm };
        newForm.initialState = {
          ...newForm.initialState,
          email: email,
        };
        setResetForm(newForm);
      }
    }
  }, [authData]);


  useEffect(() => {

    if (isReset && resetPasswordData) {
      if (resetPasswordData.errorMessage) {
        ToastService.success(resetPasswordData.errorMessage);
        if (resetPasswordData?.passwordResetRequired) {
          navigate(`/resetPassword`);
        } else {
          navigate(`/dashboard`);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReset, resetPasswordData]);

  return (
    <div className="login-page">
      <div className="logo-sec">
        <Image imagePath={AppIcons.BBCustomLogo} altText="Login Vector" />
      </div>

      <div className="login-form">
        <div className="form">
          <div className="center-icon">
            <Image imagePath={AppIcons.ResetLogo} altText="Login Vector" />
          </div>
          <div className="title-sec">
            <h1 className="title">Reset Password</h1>
            <p className="welcome-txt">
              Enter your new password to regain access.
            </p>
          </div>
          <form className="reset-form-section">
            <FormCreator
              ref={resetPasswordRef}
              config={resetForm}
            ></FormCreator>
          </form>
          <div className="btn-sec">
            <Buttons
              buttonTypeClassName="login-btn"
              titleText="RESET PASSWORD"
              buttonText="RESET PASSWORD"
              onClick={handleClick}
              isLoading={isResetting}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
